import { useAppTranslation } from "@/utils";
import { Flex, Grid, Menu, Typography } from "@payping/web-components";
import { FeatherLeft, PhRArrowsLeftRight, PhRBarcode, PhRChartBar, PhRFile } from "@payping/icons";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { usePermission } from "@/utils/usePermission";
import { permissionsList } from "@/router/types";

const SettlementMenu = () => {
  const { t } = useAppTranslation();
  const { lg } = Grid.useBreakpoint();
  const isIdGranted = usePermission([permissionsList.settlementID]);

  // Menu items for both desktop and mobile
  const menuItems = [
    {
      key: "overview",
      icon: <PhRFile strokeWidth={2} />,
      label: <Link to={DashboardRoutes.settlement.overview.url}>{t("settlement.title")}</Link>,
    },
    {
      key: "report",
      icon: <PhRChartBar />,
      label: <Link to={DashboardRoutes.settlement.report.list.url}>{t("settlement.report.title")}</Link>,
    },
    {
      key: "transaction",
      icon: <PhRArrowsLeftRight />,
      label: <Link to={DashboardRoutes.settlement.transaction.url}>{t("settlement.transaction.title")}</Link>,
    },
    ...(isIdGranted
      ? [
          {
            key: "id",
            icon: <PhRBarcode />,
            label: <Link to={DashboardRoutes.settlement.id.url}>{t("settlement.id.title")}</Link>,
          },
        ]
      : []),
  ];

  const desktopMenu = (
    <Flex vertical className={"!tw-h-full"}>
      {/* < تایتل = "تسویه" > */}
      <Typography.Text type={"secondary"}>{t("tabs.settlement")}</Typography.Text>

      {/* < منو گزینه تسوبه > */}
      <Menu mode="inline" className={"!tw-h-full !tw-border-b-0"} items={menuItems} />
    </Flex>
  );

  const mobileMenu = (
    <Flex vertical className={"!tw-p-4 !tw-py-12"}>
      {/* < تایتل = "تسویه" > */}
      <Typography.Title className={"!tw-mb-8 tw-font-medium"} level={4}>
        {t("tabs.settlement")}
      </Typography.Title>

      {/* < منو گزینه تسوبه > */}
      <Menu
        mode="inline"
        className="tw-border-0"
        items={menuItems.map((item) => ({
          ...item,
          label: (
            <div className={"tw-flex tw-justify-between"}>
              <Flex justify={"space-between"}>{item.label}</Flex>
              <FeatherLeft width={14} />
            </div>
          ),
        }))}
      />
    </Flex>
  );

  return lg ? desktopMenu : mobileMenu;
};

export default SettlementMenu;
